import { useState, useEffect } from "react";
export default function ProductImagePicker({
  src,
  onChange,
  index,
  // width,
  // height,
  // radius,
  // setProduct,
  productImageHandler,
  type
}: {
  src: string;
  onChange: Function;
  index: number | undefined;
  productImageHandler: Function;
  type: boolean;
}) {
  const inner: React.CSSProperties = {
    width: "130px",
    height: "130px",
    borderRadius: "50%",
    boxShadow: "-3px 3px 10px rgba(0, 0, 0, 0.16)"

    // boxShadow:
    //   " 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.19);"
  };
  const Styles: { [key: string]: React.CSSProperties } = {
    container: {
      ...inner,
      position: "relative"
    },
    image: {
      ...inner,
      backgroundImage: `url('${src}')`,
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover"
    },
    input: { display: "none" },
    label: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#FF4734",
      borderRadius: "50%",
      width: "30px",
      height: "30px",
      position: "absolute",
      bottom: "-5%",
      right: "10px",
      cursor: "pointer",
      padding: "5px"
    }
  };
  // function productImageHandler1(names, value) {
  //   setProduct(prev => {
  //     let temp1 = { ...prev.info };
  //     console.log("temp", temp1);
  //     console.log("change image : ", temp1);

  //     temp1 = { ...temp1, [names]: value };
  //     return { ...product, info: temp1 };
  //   });
  // }
  return (
    <div style={Styles.container}>
      <div style={Styles.image}></div>
      <input
        type="file"
        id={`product-image-picker${index ? "-" + index.toString() : ""}`}
        style={Styles.input}
        onChange={e => {
          console.log(productImageHandler);
          productImageHandler("imageSource", e.target.files[0]);
        }}
        // onChange={e => {
        //   console.log(e.target.files[0]);
        //   setProduct(prev => {
        //     return {
        //       ...prev,
        //       ["imageSource"]: e.target.files[0]
        //     };
        //   });
        // setimg(URL.createObjectURL(e.target.files[0]));
        // }}
      />
      {/* /> */}
      {type && (
        <label
          htmlFor={`product-image-picker${index ? "-" + index.toString() : ""}`}
          style={Styles.label}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g
              id="Icon_feather-plus"
              data-name="Icon feather-plus"
              transform="translate(-6 -6)"
            >
              <path
                id="Path_301"
                data-name="Path 301"
                d="M18,7.5v21"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="3"
              />
              <path
                id="Path_302"
                data-name="Path 302"
                d="M7.5,18h21"
                fill="none"
                stroke="#fff"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="3"
              />
            </g>
          </svg>
        </label>
      )}
    </div>
  );
}
